import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import naive from 'naive-ui';

import App from './App.vue';
import { routes } from './router';
import { setupRouterGuards } from './router/guards';

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes
});

// 设置路由守卫
setupRouterGuards(router);

// 创建应用实例
const app = createApp(App);

// 安装插件
app.use(createPinia());
app.use(router);
app.use(naive);

// 挂载应用
app.mount('#app');